export enum PricingProfileAdminUserRole {
  OWNER = 'owner',
  USER = 'user',
}
